import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TemplateContext } from 'src/app/models/reportTemplate.model';
import { TemplateProcessorService } from '../../../report-generation-popup/services/template-processor.service';
import { cocSampleTableLoopTemplate } from './coc-sample-table-widget.config';

@Component({
    standalone: true,
    selector: 'app-coc-sample-table-widget',
    templateUrl: './coc-sample-table-widget.component.html',
    styleUrl: './coc-sample-table-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CocSampleTableWidgetComponent {
    html: SafeHtml = '';

    constructor(private templateProcessor: TemplateProcessorService, private sanitizer: DomSanitizer) { }

    @Input() set context(context: TemplateContext | null) {
        const rendered = context ? this.templateProcessor.render(cocSampleTableLoopTemplate, context).html : '';
        this.html = this.sanitizer.bypassSecurityTrustHtml(rendered);
    }
}
